import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { dripKeys, contactKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useTestFastForwardDrip = () => {
    const additional = useQueryRequestParams();
    const queryClient = useQueryClient();
    return useMutation({
        // Hook variables carry drip_id/profile_id for cache invalidation, but
        // the request body must contain only drip_instance_id — the other two
        // fields are never serialized into it.
        mutationFn: (vars) => axios.post(markUrl('drips/test/fast-forward/'), { drip_instance_id: vars.drip_instance_id }, additional),
        onSuccess: (_response, vars) => {
            queryClient.invalidateQueries({ queryKey: dripKeys.statsRoot(vars.drip_id) });
            queryClient.invalidateQueries({ queryKey: contactKeys.detail(vars.profile_id) });
            queryClient.invalidateQueries({
                queryKey: contactKeys.engagementRoot(vars.profile_id)
            });
        }
    });
};
export default useTestFastForwardDrip;
